import React, { Component } from 'react';
import './App.css';
import Routes from './route';
import MusicList from "./components/Music-List";
import axios from './tokenInterceptor';
import { Link } from "react-router-dom";


class App extends Component  {
  constructor(props) {
    super(props);
    this.state ={
      "tracks":[]
    }
  }

  // componentWillMount() {
  //     var a = document.createElement('script'); a.type = 'text/javascript';
  //     a.async = true; a.id = 'amazon-login-sdk';
  //     a.src = 'https://assets.loginwithamazon.com/sdk/na/login1.js';
  //     d.getElementById('amazon-root').appendChild(a);
  // }
  //
  // componentDidMount() {
  //
  // }

    SearchChange =(event)=>{
    let basicToken  = localStorage.getItem("auth-token");
    let config = {
      headers: {
        'Authorization': 'Bearer '+basicToken,
      }
    };
    axios.get('https://external.us-east-1.gamma.api.music.a2z.com/library/playlists/',{
      headers:{
        'Cache-Control': 'no-cache',
        Accept: 'application/json',
        Authorization:'Atza|IwEBIJO3SI-sj0amfb_ixIlYIB0Fo6kySL-nINr8VInpm86euAwleYUBlPYaFRnU2xnvbz7oxn1HaFdiyqhQj-GoBUamWqAlaN5dRYgkDZLN9R6RE-2kpz6wCwuTxCTUrLD8zDDnUAq97d2tPO3c60PUssYz3XDINWbJnCP40yANMRuvpPeiAve7xg4gFBbTbpYQ9WF1ELTP4WrBtK6IerEx-eRvSGKAI1u7EmauUiFR96xcvhDfFsudcx63ro4GixQ9qIFZ7IfO2OCn2M4-GIdO13y8pHoa5p-gTQ_qKBKAiR-1K3WMawIBvbZ6m8iEy-vImH0j97Tnaju-dvUXSD9FA91TdPlRnOGDoiLC3O3QBkyN_-mcc-XIehzRfKrXPuErm0Jmb6bgNWKWo4QRge5LQl1JEwE5-nPvKURCpyaJUT03farImahItAFMv-V_W5SIP1Y3qy-1FzLppEWVOrcKlbNHXfxx5qtdTxJt7k1QlU3D_A545KVnq4-AXTRZAASUeGqwvV3FIAzooK9O1YVa_x9f88zp23T-o6fm1G5_DReW0zpi3WZQbdnC-X8XMMWwt-E'
      }
    }, config).then((res)=>{
      console.log('get the data ==',res);
      if(res.status == 200) {
        let td = res.data.data.trackDefinitions;
        let num = Object.keys(td).length;
        let tracksContents =[]
        for(let i=0; i<num; i++) {
        let key = "catalog_tracks_search_track_def_"+i;
        let data = td[key];
        tracksContents.push(data);
        };
        this.setState({tracks:tracksContents});    
    } else {
      this.setState({tracks:[]});
    }
    })
  }
  render() {
    return (
      <div>
        <MusicList/>
        <div className="topnav">
          <input 
            type="text" 
            placeholder="Search for Songs, Artists, Playlists and More"
            onChange={this.SearchChange}
          />
          {
            <ul className="search-list">
              {this.state.tracks.map((data, index)=>{
                return <li key={index} className="song-title">
                  <Link to={`/song/${data.title}`} >
                    <img src={data.image.uri} style={{"width":"50px", "height":"50px"}}/>
                    <a className="title" style={{"cursor": "pointer"}} >{data.title}</a>
                  </Link>
                </li>
              })}
            </ul>
          }
        </div>
        <Routes/>
      </div>
    );
  }
}

export default App;
